// Světlý / tmavý / systémový režim.
// Volba se ukládá do cookie `mx_theme`, aby ji server vykreslil rovnou do <html data-theme>
// a stránka při načtení neproblikla. Při změně se vyšle událost `mx:themechange`.

const COOKIE = 'mx_theme';
const MODES = ['system', 'light', 'dark'];

export function getThemeMode() {
  const m = document.cookie.match(/(?:^|; )mx_theme=([^;]+)/);
  return m && MODES.includes(m[1]) ? m[1] : 'system';
}

export function applyTheme(mode) {
  const root = document.documentElement;
  if (mode === 'system') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', mode);
  document.cookie = `${COOKIE}=${mode}; path=/; max-age=31536000; SameSite=Lax`;
  window.dispatchEvent(new CustomEvent('mx:themechange', { detail: { mode } }));
}

export function initTheme() {
  // Změna systémového režimu se projeví jen ve volbě „system“
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
    if (getThemeMode() === 'system') window.dispatchEvent(new CustomEvent('mx:themechange', { detail: { mode: 'system' } }));
  });
}

// Alpine komponenta pro přepínač v sidebaru: x-data="themeSwitch"
export function themeSwitch() {
  return {
    mode: getThemeMode(),
    set(mode) { this.mode = mode; applyTheme(mode); },
  };
}
